import Select, {OnChangeValue} from 'react-select';
import {useAsyncResource} from 'use-async-resource';
import {Filter, Option, User} from '../models/table-models';
import {useGetLogOperations} from '../utils/logger-hooks';
import {useTranslation} from 'react-i18next';
import {useGetUsers} from "../utils/users-hooks";

export interface FilterMultiSelectProps {
    filter: Filter;
    setFilter: React.Dispatch<React.SetStateAction<Filter>>;
}

export const LogsMultiSelect = ({filter, setFilter}: FilterMultiSelectProps) => {
    const {t} = useTranslation('translation', {keyPrefix: 'logs'});

    const onChange = (value: OnChangeValue<Option, true>) => {
        let strings = value.map(({value}) => value);
        setFilter({...filter, tags: strings});
    };
    const [getDistributors] = useAsyncResource(useGetUsers, undefined, 'DISTRIBUTOR,INSTALLER,ADMIN,COORDINATOR,FINANCIAL,WAREHOUSE');
    const {items} = getDistributors();

    const onChangeDistributor = (user: OnChangeValue<User, false>) => {
        const id = user?.id ? String(user?.id) : undefined;
        setFilter({...filter, id});
    };

    const [options] = useAsyncResource(useGetLogOperations, []);
    const logs = options();
    return (
        <div className={"w-100 d-flex justify-content-end"}>
            <Select
                className='logs-select'
                placeholder={t('filterTags')}
                isMulti
                name='colors'
                isClearable={true}
                options={logs}
                getOptionLabel={(option) => t(option.name)}
                getOptionValue={(option) => option.value}
                onChange={onChange}
                backspaceRemovesValue={true}
            />
            <Select
                className='logs-select'
                placeholder={t('distributor')}
                name='colors'
                isClearable
                options={items}
                getOptionLabel={({name}) => name}
                getOptionValue={({username}) => username}
                onChange={(newValue) => onChangeDistributor(newValue)}
                backspaceRemovesValue
            />
        </div>
    );
};
